import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  class: "flex flex-col gap-2 my-4"
};
const _hoisted_2 = {
  class: "flex flex-wrap items-start"
};
const _hoisted_3 = {
  class: "flex-1 box-border w-1/6"
};
const _hoisted_4 = {
  class: "flex-1 px-4 box-border w-1/6"
};
const _hoisted_5 = {
  class: "font-medium"
};
const _hoisted_6 = {
  key: 0,
  class: "flex-1 px-4 box-border w-1/6"
};
const _hoisted_7 = {
  class: "font-medium"
};
const _hoisted_8 = {
  key: 1,
  class: "flex-1 px-4 box-border w-1/6"
};
const _hoisted_9 = {
  class: "font-medium"
};
const _hoisted_10 = {
  key: 2,
  class: "flex-1 px-4 box-border w-2/6 invoice-number-wrapper"
};
const _hoisted_11 = {
  class: "flex-1 px-4 box-border w-1/6"
};
const _hoisted_12 = {
  key: 0,
  class: "flex flex-wrap gap-4"
};
const _hoisted_13 = {
  class: "font-medium"
};
import { computed } from 'vue';
import { useInvoiceState } from '@/modules/billing/review/editDraft/useInvoiceState';
import { useMeStore } from '@/services/UserService/useMeStore';
import { useInvoiceEditorStore } from '@/modules/billing/invoice/services/useInvoiceEditorStore.js';
import { storeToRefs } from 'pinia';
import LlTextField from '@/components/LlTextField.vue';
import LlDatePicker from '@/components/LlDatePicker.vue';
export default {
  __name: 'InvoiceHeader',
  setup(__props) {
    const {
      setInvoiceDate,
      setInvoiceReference,
      getIsLocked
    } = useInvoiceState();
    const {
      terms
    } = storeToRefs(useMeStore());
    const {
      custom,
      reference,
      client,
      matter,
      invoiceDate,
      isSplitBilling
    } = storeToRefs(useInvoiceState());
    const {
      isSaving,
      onlyViewInvoice
    } = storeToRefs(useInvoiceEditorStore());
    const additionalCustomFields = computed(() => (custom.value || []).slice(2, 6).filter(Boolean));
    const handleDateChange = () => {
      setInvoiceDate(invoiceDate.value);
    };
    const handleReferenceChange = () => {
      setInvoiceReference(reference.value);
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_cache[4] || (_cache[4] = _createElementVNode("span", {
        class: "font-medium"
      }, "Client:", -1)), _createTextVNode(" " + _toDisplayString(_unref(client)?.label || _unref(client)?.name), 1)]), _createElementVNode("div", _hoisted_4, [_createElementVNode("span", _hoisted_5, _toDisplayString(_unref(terms)?.Matter) + ":", 1), _createTextVNode(" " + _toDisplayString(_unref(matter).label || 'Multiple'), 1)]), _unref(custom)[1] && !_unref(isSplitBilling) ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("span", _hoisted_7, _toDisplayString(_unref(custom)[1].label) + ":", 1), _createTextVNode(" " + _toDisplayString(_unref(custom)[1].value), 1)])) : _createCommentVNode("", true), _unref(custom)[0] && !_unref(isSplitBilling) ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("span", _hoisted_9, _toDisplayString(_unref(custom)[0].label) + ":", 1), _createTextVNode(" " + _toDisplayString(_unref(custom)[0].value), 1)])) : _createCommentVNode("", true), !_unref(isSplitBilling) ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createVNode(LlTextField, {
        "incoming-name": 'invoiceNumber',
        placeholder: "Automatic",
        modelValue: _unref(reference),
        "onUpdate:modelValue": [_cache[0] || (_cache[0] = $event => _isRef(reference) ? reference.value = $event : null), _cache[1] || (_cache[1] = $event => handleReferenceChange())],
        "data-cy": 'invoice-number',
        readonly: _unref(onlyViewInvoice) || _unref(getIsLocked) || _unref(isSaving),
        "incoming-class": {
          'no-print': !_unref(reference)
        },
        "hide-details": true,
        label: "Invoice #",
        info: "You can enter an invoice number here for your QuickBooks invoice. If you leave this blank, QuickBooks will create an invoice number for you automatically."
      }, null, 8, ["modelValue", "readonly", "incoming-class"])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_11, [_createVNode(LlDatePicker, {
        modelValue: _unref(invoiceDate),
        "onUpdate:modelValue": [_cache[2] || (_cache[2] = $event => _isRef(invoiceDate) ? invoiceDate.value = $event : null), _cache[3] || (_cache[3] = $event => handleDateChange())],
        "data-cy": 'invoice-date',
        disabled: _unref(onlyViewInvoice) || _unref(getIsLocked) || _unref(isSaving),
        label: "Invoice Date",
        showButton: false
      }, null, 8, ["modelValue", "disabled"])])]), additionalCustomFields.value.length > 0 && !_unref(isSplitBilling) ? (_openBlock(), _createElementBlock("div", _hoisted_12, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(additionalCustomFields.value, (field, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: field.id || `custom-${index}`,
          class: "box-border w-1/4"
        }, [_createElementVNode("span", _hoisted_13, _toDisplayString(field.label) + ":", 1), _createTextVNode(" " + _toDisplayString(field.value), 1)]);
      }), 128))])) : _createCommentVNode("", true)]);
    };
  }
};